var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm.upgradeType == 1
            ? [
                _c(
                  "el-select",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      placeholder: "请选择APP",
                      clearable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.searchData.appId,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "appId", $$v)
                      },
                      expression: "searchData.appId"
                    }
                  },
                  _vm._l(_vm.appList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.name, value: item.appId }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      placeholder: "请选择终端",
                      clearable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.searchData.terminalType,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "terminalType", $$v)
                      },
                      expression: "searchData.terminalType"
                    }
                  },
                  [
                    _c("el-option", { attrs: { label: "ios", value: "1" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "安卓", value: "2" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "ipad", value: "3" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "安卓pad", value: "4" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "filter-item",
                  staticStyle: { width: "200px" },
                  attrs: { placeholder: "兼容APP版本", clearable: "" },
                  model: {
                    value: _vm.searchData.appVersion,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "appVersion", $$v)
                    },
                    expression: "searchData.appVersion"
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: { type: "info", icon: "el-icon-back" },
                    on: { click: _vm.onClickReturn }
                  },
                  [_vm._v("返回")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.fetchCompatibleVersionList }
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: { type: "warning", icon: "el-icon-refresh" },
                    on: { click: _vm.onClickReset }
                  },
                  [_vm._v("重置")]
                ),
                _vm._v(" "),
                _vm.auditStatus != 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: { type: "success", icon: "el-icon-plus" },
                        on: {
                          click: function($event) {
                            _vm.showDialog = true
                          }
                        }
                      },
                      [_vm._v("新增")]
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: { type: "info", icon: "el-icon-back" },
                    on: { click: _vm.onClickReturn }
                  },
                  [_vm._v("返回")]
                ),
                _vm._v(" "),
                _vm.auditStatus != 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: { type: "success", icon: "el-icon-plus" },
                        on: {
                          click: function($event) {
                            _vm.showDialog1 = true
                          }
                        }
                      },
                      [_vm._v("新增")]
                    )
                  : _vm._e()
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.upgradeType == 1
        ? [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  border: "",
                  stripe: "",
                  "highlight-current-row": ""
                }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号", width: "100" }
                }),
                _vm._v(" "),
                _vm._l(_vm.tableColumns, function(item, index) {
                  return [
                    _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        formatter: item.formatter
                      }
                    })
                  ]
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { width: "150", label: "操作" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return _vm.auditStatus != 1
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      title: "编辑",
                                      size: "mini"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onClickUpdate(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      title: "删除",
                                      size: "mini"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onClickDelete(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            : undefined
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              2
            )
          ]
        : [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  border: "",
                  stripe: "",
                  "highlight-current-row": ""
                }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号", width: "100" }
                }),
                _vm._v(" "),
                _vm._l(_vm.tableColumns1, function(item, index) {
                  return [
                    _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        formatter: item.formatter
                      }
                    })
                  ]
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { width: "150", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                title: "编辑",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onClickUpdate1(scope.row)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                title: "删除",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onClickDelete1(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              2
            )
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.versionForm.id ? "编辑" : "新增",
            width: "400px",
            visible: _vm.showDialog,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            },
            close: _vm.onDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "versionForm",
              attrs: {
                model: _vm.versionForm,
                rules: _vm.versionFormRule,
                "label-position": "left",
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "APP名称", required: "", prop: "appId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "APP",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.onAppIdChange },
                      model: {
                        value: _vm.versionForm.appId,
                        callback: function($$v) {
                          _vm.$set(_vm.versionForm, "appId", $$v)
                        },
                        expression: "versionForm.appId"
                      }
                    },
                    _vm._l(_vm.appList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.appId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "终端", required: "", prop: "terminalType" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "终端",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.onTerminalTypeChange },
                      model: {
                        value: _vm.versionForm.terminalType,
                        callback: function($$v) {
                          _vm.$set(_vm.versionForm, "terminalType", $$v)
                        },
                        expression: "versionForm.terminalType"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "ios", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "安卓", value: "2" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "ipad", value: "3" } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "安卓pad", value: "4" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.versionForm.appId && _vm.versionForm.terminalType
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "兼容APP版本",
                        required: "",
                        prop: "appVersion"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "兼容APP版本",
                            clearable: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.versionForm.appVersion,
                            callback: function($$v) {
                              _vm.$set(_vm.versionForm, "appVersion", $$v)
                            },
                            expression: "versionForm.appVersion"
                          }
                        },
                        _vm._l(_vm.versionList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.appVersion,
                              value: item.appVersion
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("el-button", { on: { click: _vm.onDialogClose } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmitVersion }
                    },
                    [_vm._v(_vm._s(_vm.versionForm.id ? "保存" : "新增"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.versionForm1.id ? "编辑" : "新增",
            width: "400px",
            visible: _vm.showDialog1,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog1 = $event
            },
            close: _vm.onDialogClose1
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "versionForm1",
              attrs: {
                model: _vm.versionForm1,
                rules: _vm.versionFormRule1,
                "label-position": "left",
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "中心板版本",
                    required: "",
                    prop: "limitOtaVersionInfoId"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "中心板版本",
                        clearable: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.fetchHardwareVersionInfoList
                      },
                      model: {
                        value: _vm.versionForm1.limitOtaVersionInfoId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.versionForm1,
                            "limitOtaVersionInfoId",
                            $$v
                          )
                        },
                        expression: "versionForm1.limitOtaVersionInfoId"
                      }
                    },
                    _vm._l(_vm.hardwareList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.otaVersion, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("el-button", { on: { click: _vm.onDialogClose1 } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmitVersion1 }
                    },
                    [_vm._v(_vm._s(_vm.versionForm1.id ? "保存" : "新增"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }